"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetOrganisationSubBrands($organisationId: String!)\n  {\n    getOrganisationSubBrands(organisationId: $organisationId) {\n      subBrandId\n      coverImageKey\n      name\n      updatedAt\n      organisationId\n    },\n  }"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getSubBrandsQuery = (0, _graphqlTag.default)(_templateObject());

var _default = function _default(organisationId) {
  return {
    query: getSubBrandsQuery,
    module: 'organisations',
    ignoreCache: true,
    buildVariables: function buildVariables() {
      return {
        organisationId: organisationId
      };
    }
  };
};

exports.default = _default;